module.exports = __webpack_public_path__ + "static/gallery_yarra_5-7cc3aa2aff61932a2e28b29a292c0b2d.jpg";